import React from "react";
import { L10n, L10nId } from "@fidget/common/i18n";
import styles from "./widgetError.css";
import classNames from "classnames";
import { WidgetButton } from "@fidget/common/components/widgetButton/widgetButton";
import { SadFace } from "@fidget/common/components/icons/sadFace/sadFace";

interface Props {
  messageId: L10nId;
  onButtonClick: () => void;
}

export const WidgetError = ({ messageId, onButtonClick }: Props) => (
  <div className={classNames(styles.wrapper, styles.overlay)}>
    <header>
      <SadFace style={{ margin: "auto" }} />
      <h2>
        <L10n id={messageId} />
      </h2>
    </header>
    <p>
      <L10n id={"signup.error.description"} />
    </p>
    <header>
      <WidgetButton buttonStyle={"primary"} onClick={onButtonClick}>
        <L10n id={"signup.error.close"} />
      </WidgetButton>
    </header>
  </div>
);
